/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/mesh/feature/factory 层；
 * 2. 负责创建拉伸族专属结果体/预览体对象；
 * 3. 该工厂统一承接 boss-extrude 与 cut-extrude，避免 MeshManager 再按特征种类分叉。
 */

import { ExtrudeFeatureDefinitionModel } from '../../../feature/definition/extrude/ExtrudeFeatureDefinition';
import { ExtrudeFeaturePrototype } from '../../../feature/prototype/extrude/ExtrudeFeaturePrototype';
import { ExtrudePreviewObject } from '../extrude/ExtrudePreviewObject';
import { ExtrudeResultObject } from '../extrude/ExtrudeResultObject';
import { FeatureMeshObjectFactory, type FeatureMeshObjectBuildInput } from './FeatureMeshObjectFactory';

/**
 * 拉伸族特征 mesh 对象工厂。
 */
export class ExtrudeMeshObjectFactory extends FeatureMeshObjectFactory {
    /**
     * @inheritdoc
     */
    public create(input: FeatureMeshObjectBuildInput) {
        if (input.isPreview) {
            if (
                input.context?.prototype instanceof ExtrudeFeaturePrototype
                && input.context.draftDefinition instanceof ExtrudeFeatureDefinitionModel
            ) {
                return new ExtrudePreviewObject({
                    prototype: input.context.prototype,
                    draftDefinition: input.context.draftDefinition,
                    meshData: input.meshData,
                    geometry: input.geometry,
                    material: input.material,
                });
            }
            return null;
        }

        if (input.context?.prototype instanceof ExtrudeFeaturePrototype) {
            return new ExtrudeResultObject({
                prototype: input.context.prototype,
                meshData: input.meshData,
                geometry: input.geometry,
                material: input.material,
            });
        }

        return null;
    }
}
